const setting_route = [
  {
    path: '/setting',
    name: "setting",
    component: resolve => {
      require(["@/views/setting/Index.vue"], resolve);
    },
    redirect: { path: "/setting/userindex/userlist" },
    meta: {
      public: false,
      title: '系统设置',
      navtype: 1,
    },
    children: [
      {
        path: "userindex",
        name: "userindex",
        component: resolve => {
          require(["@/views/setting/user/UserIndex.vue"], resolve)
        },
        meta: { title: "中心用户管理" },
        redirect: { path: "/setting/userindex/userlist" },
        children: [
          {
            path: 'userlist',
            name: "userlist",
            component: resolve => {
              require(["@/views/setting/user/UserList.vue"], resolve);
            },
            meta: {
              public: false,
              navtype: 1,
              id:[10006],
              active: ['/setting/userindex/userlist', '/setting/roleindex/rolelist', '/setting/dictLis']
            }
          },
          {
            path: 'userpage',
            name: "userpage",
            component: resolve => {
              require(["@/views/setting/user/UserPage.vue"], resolve);
            },
            meta: {
              title: '新建用户',
              navtype: 1,
              id:[10008,10009],
              active: ['/setting/userindex/userlist', '/setting/roleindex/rolelist', '/setting/dictLis']
            }
          },
        ]
      },
      {
        path: "roleindex",
        name: "roleindex",
        component: resolve => {
          require(["@/views/setting/role/RoleIndex.vue"], resolve)
        },
        meta: { title: "权限管理" },
        redirect: { path: "/setting/roleindex/rolelist" },
        children: [
          {
            path: 'rolelist',
            name: "rolelist",
            component: resolve => {
              require(["@/views/setting/role/RoleList.vue"], resolve);
            },
            meta: {
              public: false,
              navtype: 1,
              id:[10011],
              active: ['/setting/userindex/userlist', '/setting/roleindex/rolelist', '/setting/dictLis']
            },

          },
          {
            path: 'rolepage',
            name: "rolepage",
            component: resolve => {
              require(["@/views/setting/role/RolePage.vue"], resolve);
            },
            meta: {
              title: '新建角色',
              navtype: 1,
              id:[10013,10014],
              active: ['/setting/userindex/userlist', '/setting/roleindex/rolelist', '/setting/dictLis']
            }
          },
        ]
      },
      {
        path: 'dictList',
        name: "dictList",
        component: resolve => {
          require(["@/views/setting/dict/DictList.vue"], resolve);
        },
        meta: {
          title: '字典管理',
          navtype: 1,
          id:[10001],
          active: ['/setting/userindex/userlist', '/setting/roleindex/rolelist', '/setting/dictLis']
        }
      },
    ],
  },
];
export default setting_route